import { getAuth } from 'firebase/auth';

import { firebaseApneApp } from './firebaseApp';

export const firebaseAuth = getAuth(firebaseApneApp);
